enum PaymentMethodType {
    ApplePay = 'applepay',
    Barclaycard = 'barclaycard',
    Chasepay = 'chasepay',
    CreditCard = 'credit-card',
    GooglePay = 'googlepay',
    Masterpass = 'masterpass',
    MultiOption = 'multi-option',
    Paypal = 'paypal',
    PaypalCredit = 'paypal-credit',
    VisaCheckout = 'visa-checkout',
}

export default PaymentMethodType;
